var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonOffset48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1616 22.2778H25.0545L26.001 42.4694H22.2151L23.1616 22.2778Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1081 22.2776C25.8505 22.2776 27.263 18.7463 27.263 14.3903C27.263 10.0342 25.8505 6.50293 24.1081 6.50293C22.3656 6.50293 20.9531 10.0342 20.9531 14.3903C20.9531 18.7463 22.3656 22.2776 24.1081 22.2776Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.37 23.5389C24.6336 25.118 27.2371 27.8906 31.185 29.7315C35.1329 31.5725 38.9303 31.7847 39.6667 30.2055C40.403 28.6264 37.7996 25.8538 33.8516 24.0129C29.9037 22.1719 26.1063 21.9597 25.37 23.5389Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.63 23.5389C23.3664 25.118 20.7629 27.8906 16.815 29.7315C12.8671 31.5725 9.06971 31.7847 8.33333 30.2055C7.59695 28.6264 10.2004 25.8538 14.1484 24.0129C18.0963 22.1719 21.8937 21.9597 22.63 23.5389Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1079 27.3257C26.1988 27.3257 27.8939 25.6307 27.8939 23.5398C27.8939 21.4489 26.1988 19.7539 24.1079 19.7539C22.017 19.7539 20.322 21.4489 20.322 23.5398C20.322 25.6307 22.017 27.3257 24.1079 27.3257Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonOffset48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonOffset48.5d72fed97f415d3838728e581a85311f.svg";
export { ForwardRef as ReactComponent };